module.exports = __webpack_public_path__ + "img/85200.b8c4618d.jpg";